import hasFloatValidDigits from '~/utils/Number/hasFloatValidDigits';

export default function isValidDosage(dosage: number): boolean {
	return dosage > 0 && hasFloatValidDigits(dosage, 17, 10);
}
